import { VCarousel } from 'vuetify/lib/components/VCarousel';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCarousel,{key:_vm.$vuetify.theme.primaryText,staticClass:"elevation-0",attrs:{"hide-delimiters":"","cycle":"","interval":"25000","height":"auto","light":""},on:{"change":_vm.onCarouselSelected}},[_vm._l((_vm.banners),function(banner){return [_c('canvas-item',{key:banner,attrs:{"p_animationName":banner,"p_isSelected":(banner === _vm.selectedItem)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }